// src/router/index.ts
import { createRouter, createWebHistory, RouteRecordRaw, RouterView } from 'vue-router'

import HomeView from '@/views/HomeView.vue'
import DocumentsView from '@/views/DocumentsView.vue'
import LoansView from '@/views/LoansView.vue'
import PrivatePensionView from '@/views/PrivatePensionView.vue'
import PensionRights from '@/views/PensionRights.vue'
import PensionPayments from '@/views/PensionPayments.vue'
import SettingsView from '@/views/SettingsView.vue'
import ApplicationView from '@/views/ApplicationView.vue'
import PageNotFoundView from '@/views/PageNotFound.vue'
import ImpersonateView from '@/views/ImpersonateView.vue'

import { useAuthStore } from '@/stores/useAuthStore'
import LanaSkjolIframe from '@/components/FiveDegrees/LanaSkjolIframe.vue'
import ApplicationsListLifeyriView from '@/views/Applications/ApplicationsListLifeyriView.vue'
import ApplicationsListLanView from '@/views/Applications/ApplicationsListLanView.vue'
import ApplicationsListSereignView from '@/views/Applications/ApplicationsListSereignView.vue'
import IframeLanaUmsokn from '@/components/iframes/IframeLanaUmsokn.vue'
// import ApplicationRadstofunSereign from '@/components/Applications/Radsofun_Sereign/ApplicationRadstofunSereign.vue'
import ApplicationEllilifeyri from '@/components/Applications/Ellilifeyri/ApplicationEllilifeyri.vue'
import ApplicationBarnalifeyri from '@/components/Applications/Barnalifeyri/ApplicationBarnalifeyri.vue'
import ApplicationLanNafnabreyting from '@/components/Applications/LanNafnabreyting/ApplicationLanNafnabreyting.vue'
import LanGreidslufrestUmsokn from '@/components/Applications/Lan_greidslufrest/LanGreidslufrestUmsokn.vue'
import ApplicationLanVedflutning from '@/components/Applications/LanVedflutning/ApplicationLanVedflutning.vue'
import pensionCalculatorView from '@/views/pensionCalculatorView.vue'
import loanCalculator from '@/components/calculators/loanCalculator.vue'
import ApplicationSent from '@/components/Applications/Shared/ApplicationSent.vue'
import ApplicationSereign from '@/components/Applications/Sereign/ApplicationSereign.vue'
import ApplicationMakaLifeyri from '@/components/Applications/Makalifeyri/ApplicationMakaLifeyri.vue'
import ApplicationTilgreindSereign from '@/components/Applications/Tilgreind_Sereign/ApplicationTilgreindSereign.vue'
import ApplicationOrorka from '@/components/Applications/OrorkuLifeyri/ApplicationOrorka.vue'
import ApplicationUtgreidslaSereignUmsokn from '@/components/Applications/UtgreidslaSereignUmsokn/ApplicationUtgreidslaSereignUmsokn.vue'
import ApplicationNewLaunaGreidandi from '@/components/Applications/NewLaunaGreidandi/ApplicationNewLaunaGreidandi.vue'
import ApplicationBreytingSereign from '@/components/Applications/BreytingSereignUmsokn/ApplicationBreytingSereign.vue'
import Uppsogn_sereign_umsokn from '@/components/Applications/UppsognSereign/Uppsogn_sereign_umsokn.vue'
import Afsal_Umsokn from '@/components/Applications/AfsalArfshlutaSereign/Afsal_Umsokn.vue'
import IdgjaldView from '@/views/IdgjoldView.vue'

// Admin view (hidden route)
import AdminView from '@/components/Admin/AdminView.vue'
import Undirritun from '@/components/Applications/Shared/Undirritun.vue'

const EmptyView = { name: 'EmptyView', template: '<div />' }

const routes: RouteRecordRaw[] = [
  { path: '/', component: HomeView, meta: { breadcrumb: 'Frontpage_link' } },
  {
    path: '/lifeyrir',
    component: RouterView,
    meta: { breadcrumb: 'lifyerir_heading_new' },
    children: [
      { path: 'rettindi', component: PensionRights, meta: { breadcrumb: 'menu_item_lifeyrisrettindi' } },
      { path: 'greidslur', component: PensionPayments, meta: { breadcrumb: 'frontpage_navbar_6' } },
    ],
  },
  { path: '/nanar-lan', component: LoansView, meta: { breadcrumb: 'frontpage_navbar_4', titleKey: 'frontpage_navbar_4' } },
  { path: '/idgjold', component: IdgjaldView, meta: { breadcrumb: 'idgjoldundirsida_header1', titleKey: 'idgjoldundirsida_header1' } },
  { path: '/sereign', component: PrivatePensionView, meta: { breadcrumb: 'frontpage_navbar_3', titleKey: 'frontpage_navbar_3' } },
  { path: '/undirritun', component: Undirritun,  name: 'Undirritun', meta: { breadcrumb: 'frontpage_navbar_3', titleKey: 'frontpage_navbar_3' } },
  {
    path: '/umsoknir',
    component: RouterView,
    meta: { breadcrumb: 'umsoknundirsida_text_header', titleKey: 'umsoknundirsida_text_header' },
    children: [
      {
        path: 'lifeyrir',
        component: ApplicationsListLifeyriView,
        meta: { breadcrumb: 'lifyerir_heading_new', titleKey: 'lifyerir_heading_new' },
        children: [
          { path: 'ellilifeyrir', component: ApplicationEllilifeyri, meta: { titleKey: 'umsoknundirsida_ellilifeyrir_link' } },
          { path: 'barnalifeyrir', component: ApplicationBarnalifeyri, meta: { titleKey: 'umsoknir_eydublod_barnalifeyri_hlekkur_texti' } },
          { path: 'makalifeyrir', component: ApplicationMakaLifeyri, meta: { titleKey: 'umsoknir_eydublod_makalifeyrir_hlekkur_texti' }},
          { path: 'ororkuumsokn', component: ApplicationOrorka, meta: { titleKey: 'umsoknir_eydublod_endurhaefingarororkulifeyri_hlekkur_texti' } },
        ],
      },
      {
        path: 'lan',
        component: ApplicationsListLanView,
        meta: { breadcrumb: 'frontpage_navbar_4', titleKey: 'frontpage_navbar_4' },
        children: [
          { path: 'lanaumsokn', component: IframeLanaUmsokn, meta: { titleKey: 'lanaundirsida_link' } },
          { path: 'lan-nafnabreyting', component: ApplicationLanNafnabreyting, meta: { titleKey: 'umsoknir_eydublod_beidniumnafnabreytingu_texti'} },
          { path: 'lan-greidslufrest', component: LanGreidslufrestUmsokn, meta: { titleKey: 'umsoknir_eydublod_greidslufrestur_hlekkur_texti', disabled: false } },
          { path: 'lan-vedflutning', component: ApplicationLanVedflutning, meta: { titleKey: 'umsoknir_eydublod_beidniumvedfluttning_texti' } },
        ],
      },
      {
        path: 'sereign',
        component: ApplicationsListSereignView,
        meta: { breadcrumb: 'frontpage_navbar_3', titleKey: 'frontpage_navbar_3' },
        children: [
          { path: 'sereignaumsokn', component: ApplicationSereign, meta: { titleKey: 'umsoknir_eydublod_sereignasparnadur_texti' } },
          { path: 'tilgreind-sereign', name: 'TilgreindSereign', component: ApplicationTilgreindSereign, meta: { titleKey: 'umsoknir_eydublod_tilgreindsereign_texti' } },
          { path: 'utgreidslaumsokn', component: ApplicationUtgreidslaSereignUmsokn, meta: { titleKey: 'umsoknundirsida_sereign_utgreidsla_link', disabled: false } },
          { path: 'nyr-launagreidandi', component: ApplicationNewLaunaGreidandi, meta: { titleKey: 'umsoknir_eydublod_nyr_launagreidandi_texti', disabled: false } },
          { path: 'breytingsereign', component: ApplicationBreytingSereign, meta: { titleKey: 'umsoknir_eydublod_breytingsereign_texti', disabled: false } },
          { path: 'uppsogn-samning', component: Uppsogn_sereign_umsokn, meta: { titleKey: 'umsoknir_eydublod_uppsogn_samning_texti', disabled: false } },
          { path: 'afsal_sereign', component: Afsal_Umsokn, meta: { titleKey: 'umsoknir_eydublod_afsal_sereign_texti', disabled: false } },
          // { path: 'radstofun-idgjalds', component: ApplicationRadstofunSereign, meta: { titleKey: 'umsoknir_eydublod_radstofun_idgjalds_texti' } },
        ],
      },
    ],
  },

  { path: '/Umsokn-mottekin', name: 'ApplicationSent', meta: { titleKey: 'standard_email_subject' }, component: ApplicationSent },

  {
    path: '/skjol',
    component: RouterView,
    meta: { breadcrumb: 'frontpage_navbar_8', titleKey: 'frontpage_navbar_8' },
    redirect: '/skjol/sjodfelaga',
    children: [
      { path: 'sjodfelaga', component: DocumentsView, meta: { breadcrumb: 'lan_skjol_tab_1', titleKey: 'lan_skjol_tab_1' } },
      { path: 'lanaskjol', component: LanaSkjolIframe, meta: { breadcrumb: 'lan_skjol_tab_2', titleKey: 'lan_skjol_tab_2' } },
    ],
  },

  {
    path: '/reiknivelar',
    component: RouterView,
    meta: { breadcrumb: 'calculate_header', titleKey: 'calculate_header' },
    redirect: '/reiknivelar/lifeyrisreiknivel',
    children: [
      { path: 'lifeyrisreiknivel', component: pensionCalculatorView, meta: { breadcrumb: 'pension_calculator_header', titleKey: 'pension_calculator_header' } },
      { path: 'lanareiknivel', component: loanCalculator, meta: { breadcrumb: 'loan_calculator_header', titleKey: 'loan_calculator_header' } },
    ],
  },

  // Admin route (hidden + guarded)
  {
    path: '/admin',
    name: 'admin',
    component: AdminView,
    meta: {
      titleKey: 'admin',
      requiresSuperUser: true, // hard guard
      hideInNav: true,         // keep out of menus
    },
  },

  { path: '/stillingar', component: SettingsView, meta: { breadcrumb: 'stillingar_header' } },
  { path: '/impersonate', component: ImpersonateView,     meta: {
      titleKey: 'impersonate',
      requiresSuperUser: true, // hard guard
      hideInNav: true,         // keep out of menus
    },},
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: PageNotFoundView },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Global auth + superuser guard
router.beforeEach(async (to) => {
  const authStore = useAuthStore()

  // Resolve auth once (safe to call multiple times)
  if (!authStore.isAuthResolved) {
    try { await authStore.getAuthUser() } catch {}
  }

  // Block admin routes when not superuser
  if (to.meta?.requiresSuperUser && !authStore.isSuperUser) {
    return { path: '/', replace: true }
  }

  // Check if user needs to complete setup (only if logged in)
  if (authStore.isLoggedIn && to.path !== '/stillingar') {
    const hasCheckedSetup = sessionStorage.getItem('hasCheckedSetup')
    
    if (!hasCheckedSetup) {
      try {
        const UseCalaUser = (await import('@/composables/UseCalaUser')).default
        const { getCalaUser } = UseCalaUser()
        const resp = await getCalaUser()
        
        let customer: any = resp?.user
        if (!customer) {
          customer = resp?.item1 ?? (Array.isArray(resp) ? resp[0] : null)
        }

        const needsSetup = !customer?.email || String(customer.email).trim() === ''
        
        sessionStorage.setItem('hasCheckedSetup', 'true')
        
        if (needsSetup) {
          return { path: '/stillingar', replace: true }
        }
      } catch (e: any) {
        const status = e?.response?.status ?? e?.status
        if (status === 404) {
          sessionStorage.setItem('hasCheckedSetup', 'true')
          return { path: '/stillingar', replace: true }
        }
        // Other errors: let user through
        sessionStorage.setItem('hasCheckedSetup', 'true')
      }
    }
  }

  return true
})

export default router
